import { SxProps, Theme } from '@mui/material';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { ReactElement } from 'react';
import { backgroundColorDarkTheme } from '../../styles/global.styles';

interface ChipListComponentProps {
  chipData: string[];
  chipIcon?: ReactElement;
  onDelete: (index: number) => void;
  chipSx?: SxProps<Theme>;
  maxChipWidth?: string | number;
}

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const ChipListComponent = ({
  chipData,
  chipIcon,
  onDelete,
  chipSx,
  maxChipWidth = 300,
}: ChipListComponentProps) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        p: 0.5,
        m: 0,
        backgroundColor: '#343434',
      }}
      component="ul"
    >
      {chipData.map((data, index) => (
          <ListItem key={`${data}-${index}`}>
            <Chip
              sx={{
                backgroundColor: backgroundColorDarkTheme,
                maxWidth: maxChipWidth,
                '& .MuiChip-label': {
                  display: 'block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
                ...chipSx,
              }}
              icon={chipIcon}
              label={data}
              title={data}
              onDelete={() => onDelete(index)}
            />
          </ListItem>
      ))}
    </Paper>
  );
};

export default ChipListComponent;
